/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const UPDATE_PREF = 'UPDATE_PREF';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const SET_PLAGIARISM_RUN = 'SET_PLAGIARISM_RUN';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const ADD_PLAGIARISM_CASES = 'ADD_PLAGIARISM_CASES';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const SET_PLAGIARISM_PROMISE = 'SET_PLAGIARISM_PROMISE';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const CLEAR_PLAGIARISM_RUN = 'CLEAR_PLAGIARISM_RUN';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const CLEAR_PLAGIARISM_RUNS = 'CLEAR_PLAGIARISM_RUNS';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const SET_AUTO_TEST = 'SET_AUTO_TEST';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const DELETE_AUTO_TEST = 'DELETE_AUTO_TEST';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const UPDATE_AUTO_TEST = 'UPDATE_AUTO_TEST';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const UPDATE_AUTO_TEST_RUNS = 'UPDATE_AUTO_TEST_RUNS';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const UPDATE_AUTO_TEST_SET = 'UPDATE_AUTO_TEST_SET';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const DELETE_AUTO_TEST_SUITE = 'DELETE_AUTO_TEST_SUITE';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const UPDATE_AUTO_TEST_RESULT = 'SET_AUTO_TEST_RESULT';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const DELETE_AUTO_TEST_RESULT = 'DELETE_AUTO_TEST_RESULT';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const SET_AUTO_TEST_RESULTS_BY_USER = 'SET_AUTO_TEST_RESULTS_BY_USER';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const CLEAR_AUTO_TESTS = 'CLEAR_AUTO_TESTS';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const CLEAR_AUTO_TEST_RUN = 'CLEAR_AUTO_TEST_RUN';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const SET_RUBRIC = 'SET_RUBRIC';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const CLEAR_RUBRIC = 'CLEAR_RUBRIC';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const SET_RUBRIC_RESULT = 'SET_RUBRIC_RESULT';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const CLEAR_RUBRIC_RESULT = 'CLEAR_RUBRIC_RESULT';
/** The mutation to clear the entire rubric store. */
export const CLEAR_RUBRIC_ALL = 'CLEAR_RUBRIC_ALL';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const ADD_OR_UPDATE_USER = 'ADD_OR_UPDATE_USER';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const UPDATE_GROUP_SET_PROMISE = 'UPDATE_GROUP_SET_PROMISE';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const DELETE_GROUP_USER = 'DELETE_GROUP_USER';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const CLEAR_USERS = 'CLEAR_USERS';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const SET_WORKSPACE = 'SET_WORKSPACE';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const CLEAR_ASSIGNMENT_WORKSPACES = 'CLEAR_ASSIGNMENT_WORKSPACES';
